//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "tab-menu",
  data() {
    return {
      menus: [
        {
          key: "home",
          path: "/home",
          name: "首页",
          activeIcon:
            "https://static.soyoung.com/sy-pre/home--checked-1677737400779.png",
          unactiveIcon:
            "https://static.soyoung.com/sy-pre/home--unchecked-1677737400779.png",
        },
        {
          key: "product",
          path: "/product-list",
          name: "产品",
          activeIcon:
            "https://static.soyoung.com/sy-pre/products--checked-1677737400779.png",
          unactiveIcon:
            "https://static.soyoung.com/sy-pre/product--unchecked-1677737400779.png",
        },
        {
          key: "my",
          path: "/personal",
          name: "我的",
          activeIcon:
            "https://static.soyoung.com/sy-pre/my--checked-1677737400779.png",
          unactiveIcon:
            "https://static.soyoung.com/sy-pre/my--unchecked-1677737400779.png",
        },
      ],
    };
  },
  computed: {
    activePath() {
      return this.$route.path;
    },
  },
  methods: {
    onMenuClick(menu) {
      if (menu.path === this.activePath) return;
      this.$router.push(menu.path);
    },
  },
};
